var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	21527: () => (loadSingletonVersion("default", "react", false, [4,18,2,0], () => (__webpack_require__.e(77810).then(() => (() => (__webpack_require__(77810))))))),
	47727: () => (loadSingletonVersion("default", "@emotion/cache", false, [2,11,11,0], () => (__webpack_require__.e(73470).then(() => (() => (__webpack_require__(73470))))))),
	14290: () => (loadSingletonVersion("default", "@emotion/styled", false, [4,11,11,5], () => (Promise.all([__webpack_require__.e(24578), __webpack_require__.e(21539)]).then(() => (() => (__webpack_require__(24578))))))),
	85929: () => (loadSingletonVersion("default", "react-dom", false, [4,18,2,0], () => (__webpack_require__.e(22483).then(() => (() => (__webpack_require__(22483))))))),
	10781: () => (loadSingletonVersion("default", "@emotion/react", false, [4,11,12,0], () => (__webpack_require__.e(760).then(() => (() => (__webpack_require__(78379))))))),
	1428: () => (loadStrictVersion("default", "@mui/system", false, [4,5,15,15], () => (__webpack_require__.e(45090).then(() => (() => (__webpack_require__(45090))))))),
	8133: () => (loadStrictVersion("default", "date-fns", false, [4,2,27,0], () => (__webpack_require__.e(10953).then(() => (() => (__webpack_require__(10953))))))),
	22105: () => (loadStrictVersion("default", "html-react-parser", false, [4,5,1,11], () => (__webpack_require__.e(10900).then(() => (() => (__webpack_require__(10900))))))),
	81078: () => (loadSingletonVersion("default", "react-router", false, [7,6,22,3,,"pre",0], () => (Promise.all([__webpack_require__.e(81534), __webpack_require__.e(28689)]).then(() => (() => (__webpack_require__(28689))))))),
	29202: () => (loadSingletonVersion("default", "@emotion/react", false, [4,11,12,0], () => (__webpack_require__.e(21727).then(() => (() => (__webpack_require__(44108))))))),
	80091: () => (loadStrictVersion("default", "@datadog/browser-rum", false, [4,6,24,1], () => (__webpack_require__.e(16346).then(() => (() => (__webpack_require__(16346))))))),
	43313: () => (loadStrictVersion("default", "js-cookie", false, [4,3,0,1], () => (__webpack_require__.e(18987).then(() => (() => (__webpack_require__(18987))))))),
	84942: () => (loadSingletonVersion("default", "react-router-dom", false, [7,6,22,3,,"pre",0], () => (Promise.all([__webpack_require__.e(81534), __webpack_require__.e(81342)]).then(() => (() => (__webpack_require__(81342))))))),
	8251: () => (loadSingletonVersion("default", "@im/react-localization", false, [4,1,0,376], () => (Promise.all([__webpack_require__.e(34429), __webpack_require__.e(70113)]).then(() => (() => (__webpack_require__(34429))))))),
	92578: () => (loadSingletonVersion("default", "@tanstack/react-query", false, [4,5,34,1], () => (__webpack_require__.e(86311).then(() => (() => (__webpack_require__(86311))))))),
	97220: () => (loadSingletonVersion("default", "@im/im-theme", false, [4,2,0,1111], () => (__webpack_require__.e(58598).then(() => (() => (__webpack_require__(58598))))))),
	57789: () => (loadStrictVersion("default", "@mui/system", false, [4,5,15,15], () => (__webpack_require__.e(11510).then(() => (() => (__webpack_require__(11510))))))),
	62403: () => (loadStrictVersion("default", "@im/post-msg", false, [4,1,0,8], () => (__webpack_require__.e(97142).then(() => (() => (__webpack_require__(97142))))))),
	21539: () => (loadSingletonVersion("default", "@emotion/react", false, [4,11,12,0], () => (Promise.all([__webpack_require__.e(30505), __webpack_require__.e(47727)]).then(() => (() => (__webpack_require__(30505))))))),
	70113: () => (loadStrictVersion("default", "js-cookie", false, [4,3,0,1], () => (__webpack_require__.e(46639).then(() => (() => (__webpack_require__(46639))))))),
	81216: () => (loadSingletonVersion("default", "@emotion/react", false, [4,11,12,0], () => (__webpack_require__.e(43959).then(() => (() => (__webpack_require__(66340))))))),
	13571: () => (loadSingletonVersion("default", "recoil", false, [2,0,7,7], () => (__webpack_require__.e(27006).then(() => (() => (__webpack_require__(27006)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1428": [
		1428
	],
	"10781": [
		10781
	],
	"14244": [
		80091,
		43313,
		84942,
		8251,
		92578,
		97220,
		57789,
		62403
	],
	"14290": [
		14290
	],
	"21527": [
		21527
	],
	"21539": [
		21539
	],
	"29202": [
		29202
	],
	"41411": [
		13571
	],
	"44677": [
		81216
	],
	"47727": [
		47727
	],
	"60085": [
		8133,
		22105
	],
	"70113": [
		70113
	],
	"81078": [
		81078
	],
	"85929": [
		85929
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}